import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import config from "lib/fr-config";
import { sleep } from "lib/commonUtil";
import Restful from "lib/restful";

const SET_IS_LOADING = "userDevice/SET_IS_LOADING";
const SET_VIEWER_LOCATION = "userDevice/SET_VIEWER_LOCATION";
const WAIT_MILLISEC = config.storeModule.waitForLoadingMilliSec;

const DEFAULT_LOC = "US";

/**
 * USE_USER_LOC_INFO : ip주소의 위치와 상관없이, 사용자가 가입시 설정한
 *                     위치에 해당하는 값을 사용하도록 설정하는 변수.
 */
const USE_USER_LOC_INFO = process.env.NODE_ENV === "production" ? true : false;

const setIsLoading = createAction(SET_IS_LOADING);
const setViewerLocation = createAction(SET_VIEWER_LOCATION);

export const editViewerLocation = userLoc => async (dispatch, getState) => {
  const { userDevice } = getState();
  const userDeviceState = userDevice.toJS();
  let isLoading = userDeviceState.isLoading;

  if (!USE_USER_LOC_INFO && userLoc) {
    /**
     * 함수 실행시 userLoc값이 지정된 경우, ip위치로 위치정보를 사용하는 설정이라면 함수 종료되도록 설정
     */
    return null;
  }

  while (isLoading) {
    await sleep(WAIT_MILLISEC);

    const { userDevice } = getState();
    const userDeviceState = userDevice.toJS();
    isLoading = userDeviceState.isLoading;
  }

  dispatch(setIsLoading(true));

  let loc;
  if (userLoc) {
    loc = userLoc;
  } else {
    const { code, res, errInfo } = await Restful.getViewerLocationAPI();
    if (code === "error") {
      dispatch(setViewerLocation(DEFAULT_LOC));
      dispatch(setIsLoading(false));
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }

    loc = res.loc;
  }

  dispatch(setViewerLocation(loc));
  dispatch(setIsLoading(false));
};

const initialState = fromJS({
  isLoading: false,
  viewerLocation: null
});

export default handleActions(
  {
    [SET_IS_LOADING]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [SET_VIEWER_LOCATION]: (state, action) => {
      const viewerLocation = action.payload;
      return state.set("viewerLocation", fromJS(viewerLocation));
    }
  },
  initialState
);
